export const SMALL = '721px';
export const MEDIUM = '961px';
export const LARGE = '1366px';
